import { Type } from '@sinclair/typebox';
import { UserRole } from './fortnox-user-schema.js';
import { PermissionType, ReviewPermissionType } from './permission-schema.js';
const PermissionLaxSchema = Type.Object({
    ata: Type.String(),
    forecast: Type.String(),
    invoice: Type.String(),
    overview: Type.String(),
    budget: Type.String(),
    files: Type.String(),
    review: Type.String(),
});
// Request bodies only (see `PutAdminUserRequestSchema` below), so `files` is optional for the same
// reason as in `WritePermissionModel`: a client that predates the FILES tier must still be able to
// save a user's permissions. `PermissionLaxSchema` above is response-only and keeps it required.
const PermissionStrictSchema = Type.Object({
    ata: Type.Enum(PermissionType),
    forecast: Type.Enum(PermissionType),
    invoice: Type.Enum(PermissionType),
    overview: Type.Enum(PermissionType),
    budget: Type.Enum(PermissionType),
    files: Type.Optional(Type.Enum(PermissionType)),
    review: Type.Enum(ReviewPermissionType),
});
const PermissionWithIdsSchema = Type.Intersect([
    Type.Object({
        id: Type.String(),
        projectId: Type.String(),
        userId: Type.String(),
    }),
    PermissionLaxSchema,
]);
const UserSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    email: Type.String(),
    role: Type.String(),
    status: Type.String(),
    phone: Type.Optional(Type.Union([Type.String(), Type.Null()])),
});
const ProjectSchema = Type.Object({
    id: Type.String(),
    fortnoxId: Type.String(),
    name: Type.String(),
    status: Type.Union([Type.String(), Type.Null()]),
});
const UserWithProjectsSchema = Type.Object({
    user: UserSchema,
    projects: Type.Array(ProjectSchema),
    permissions: Type.Array(PermissionWithIdsSchema),
});
// GET /admin-fortnox-users/projects
export const GetAdminUsersAndProjectsResponseSchema = Type.Array(UserWithProjectsSchema);
const PermissionsAndProjectIdSchema = Type.Intersect([
    Type.Object({
        projectId: Type.String(),
    }),
    PermissionStrictSchema,
]);
// PUT /admin-fortnox-users/:userid
export const PutAdminUserRequestSchema = Type.Object({
    user: Type.Object({
        id: Type.Optional(UserSchema.properties.id),
        name: Type.Optional(UserSchema.properties.name),
        email: Type.Optional(UserSchema.properties.email),
        role: Type.Optional(Type.Enum(UserRole)),
        status: Type.Optional(UserSchema.properties.status),
        phone: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    }),
    permissions: Type.Optional(Type.Array(PermissionsAndProjectIdSchema)),
});
